/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as privilegeV1 from "./keyapis_subscription_privilege_v1.pb"

/**
 * События устройств (домофоны, калитки, шлагбаумы)
 */

/**
 * Событие инициализации сценария обновления статусов аналоговых трубок.
 * Очередь key.subscription.cms_init
 */
export type CmsInitTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * ОРПОНы домов
   */
  orpons: string[]
}
/**
 * Событие инициализации сценария обновления статусов аналоговых трубок.
 * Очередь key.subscription.cms_init
 */
export type CmsInitTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * ОРПОНы домов
   */
  orpons: string[]
}
/**
 * Событие о появлении коммерческой возможности с услугой аналоговой трубки.
 * Очередь key.subscription.cms_available
 */
export type CommercialOfferCmsAvailableTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор ОРПОН дома
   */
  orponId: string
  /**
   * Номера квартир, с привилегией \"Аналоговая трубка\" в статусе: Оплачено, Промо, Отключается
   */
  privilegedRoomNumbers?: string[]
}
/**
 * Событие о появлении коммерческой возможности с услугой аналоговой трубки.
 * Очередь key.subscription.cms_available
 */
export type CommercialOfferCmsAvailableTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор ОРПОН дома
   */
  orponId: string
  /**
   * Номера квартир, с привилегией \"Аналоговая трубка\" в статусе: Оплачено, Промо, Отключается
   */
  privilegedRoomNumbers: string[]
}
/**
 * Событие о прекращении действия коммерческой возможности с услугой аналоговой трубки.
 * Очередь key.subscription.cms_unavailable
 */
export type CommercialOfferCmsUnavailableTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор ОРПОН дома
   */
  orponId: string
}
/**
 * Событие о прекращении действия коммерческой возможности с услугой аналоговой трубки.
 * Очередь key.subscription.cms_unavailable
 */
export type CommercialOfferCmsUnavailableTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор ОРПОН дома
   */
  orponId: string
}
/**
 * Сообщение об изменении состояния привилегии.
 * Очередь key.subscription.privilege_state_change
 */
export type PrivilegeStateChangeTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор ОРПОН дома
   */
  orponId: string
  /**
   * Номер квартиры
   */
  roomNumber: string
  /**
   * Тип привилегии
   */
  privilegeType: privilegeV1.PrivilegeTypeRequestEnum
  /**
   * Тип состояния привилегий
   */
  stateType: privilegeV1.PrivilegeStateTypeRequestEnum
  /**
   * Предыдущий тип состояния привилегии
   */
  previousStateType?: privilegeV1.PrivilegeStateTypeRequestEnum | "STATE_TYPE_UNKNOWN"
  /**
   * Дата обновления состояния привилегии
   */
  updatedAt: string
}
/**
 * Сообщение об изменении состояния привилегии.
 * Очередь key.subscription.privilege_state_change
 */
export type PrivilegeStateChangeTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор ОРПОН дома
   */
  orponId: string
  /**
   * Номер квартиры
   */
  roomNumber: string
  /**
   * Тип привилегии
   */
  privilegeType: privilegeV1.PrivilegeTypeResponseEnum
  /**
   * Тип состояния привилегий
   */
  stateType: privilegeV1.PrivilegeStateTypeResponseEnum
  /**
   * Предыдущий тип состояния привилегии
   */
  previousStateType: privilegeV1.PrivilegeStateTypeResponseEnum
  /**
   * Дата обновления состояния привилегии
   */
  updatedAt: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Событие инициализации сценария обновления статусов аналоговых трубок.
   * Очередь key.subscription.cms_init
   */
  "CmsInitTask": {
    "kind": "class",
    "text": "Событие инициализации сценария обновления статусов аналоговых трубок.\nОчередь key.subscription.cms_init",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * ОРПОНы домов
       */
      "orpons": {
        "type": "int64",
        "text": "ОРПОНы домов",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Событие о появлении коммерческой возможности с услугой аналоговой трубки.
   * Очередь key.subscription.cms_available
   */
  "CommercialOfferCmsAvailableTask": {
    "kind": "class",
    "text": "Событие о появлении коммерческой возможности с услугой аналоговой трубки.\nОчередь key.subscription.cms_available",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор ОРПОН дома
       */
      "orponId": {
        "type": "int64",
        "text": "Идентификатор ОРПОН дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номера квартир, с привилегией \"Аналоговая трубка\" в статусе: Оплачено, Промо, Отключается
       */
      "privilegedRoomNumbers": {
        "type": "string",
        "text": "Номера квартир, с привилегией \"Аналоговая трубка\" в статусе: Оплачено, Промо, Отключается",
      },
    },
  },
  /**
   * Событие о прекращении действия коммерческой возможности с услугой аналоговой трубки.
   * Очередь key.subscription.cms_unavailable
   */
  "CommercialOfferCmsUnavailableTask": {
    "kind": "class",
    "text": "Событие о прекращении действия коммерческой возможности с услугой аналоговой трубки.\nОчередь key.subscription.cms_unavailable",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор ОРПОН дома
       */
      "orponId": {
        "type": "int64",
        "text": "Идентификатор ОРПОН дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Сообщение об изменении состояния привилегии.
   * Очередь key.subscription.privilege_state_change
   */
  "PrivilegeStateChangeTask": {
    "kind": "class",
    "text": "Сообщение об изменении состояния привилегии.\nОчередь key.subscription.privilege_state_change",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор ОРПОН дома
       */
      "orponId": {
        "type": "int64",
        "text": "Идентификатор ОРПОН дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип привилегии
       */
      "privilegeType": {
        "type": "Privilege.Type",
        "text": "Тип привилегии",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип состояния привилегий
       */
      "stateType": {
        "type": "Privilege.StateType",
        "text": "Тип состояния привилегий",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Предыдущий тип состояния привилегии
       */
      "previousStateType": {
        "type": "Privilege.StateType",
        "text": "Предыдущий тип состояния привилегии",
      },
      /**
       * Дата обновления состояния привилегии
       */
      "updatedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата обновления состояния привилегии",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
}